import { useCookies } from 'react-cookie';

export const useCookiesLogin = ()=>{
    const [cookies, setCookies, removeCookie ] = useCookies(['BRAUM_TOKEN']);
    return { cookies, setCookies, removeCookie };
}
